import {useContext} from 'react';
import {EventCreateContext} from '~/common/FabricInvitation/EventCreateDesign/EventCreateContext';
import {ActionButtons} from './components/ActionButtons';
import {FiltersSection} from './components/FiltersSection';
import {PhotoEditorHeader} from './components/PhotoEditorHeader';
import {TransformSection} from './components/TransformSection';

import './UyoControl.sass';

export const UyoControl = ({editorDisabled}) => {
  const {canvas, activeObjects, processing} = useContext(EventCreateContext);
  const id = activeObjects?.[0]?.id;

  return (
    <div key={id} className={`uyo-control-container ${editorDisabled ? 'disabled' : ''}`}>
      <PhotoEditorHeader canvas={canvas} />

      <ActionButtons canvas={canvas} id={id} editorDisabled={editorDisabled} />
      <TransformSection canvas={canvas} processing={processing} />

      <FiltersSection canvas={canvas} />
    </div>
  );
};
